import React from "react";
import "./TagCloud.css";

const TagCloud = () => {
  return (
    <div className="whatsNew container--full">
      {/* <h3>Tag cloud</h3> */}
      <div className='container'>
        <div className="whatsNew-cloud">
          <p className="item-1">Android</p> 
          <p className="item-2">Multiplatform</p> 
          <p className="item-3">Migration</p> 
          <p className="item-4">Blockchain</p> 
          <p className="item-5">Testing</p> 
          <p className="item-6">Kotlin</p> 
          <p className="item-7">Modularization</p> 
          <p className="item-8">Flows</p> 
          <p className="item-9">Native</p> 
          <p className="item-10">Jetpack Compose</p> 
          <p className="item-11">Dynamic Features</p> 
          <p className="item-12">App performance</p> 
          <p className="item-13">App vitals</p> 
          <p className="item-14">Gradle</p>
          <p className="item-15">Architecture</p>
          <p className="item-16">Java</p> 
          <p className="item-17">OWASP</p> 
          <p className="item-18">Mobile Design System</p> 
          <p className="item-19">Xamarin</p> 
          <p className="item-20">.NET Android</p> 
          <p className="item-21">MVVM</p> 
          <p className="item-22">AI</p> 
          <p className="item-23">Android Apps</p> 
          <p className="item-24">KMM</p> 
        </div>
      </div>
    </div>
  );
};
export default TagCloud;






 
 






 








